import KidsCourses from './KidsCourses';

export { KidsCourses };
export default KidsCourses;
